export const PAGINATION_CONSTANTS = {
    UNLIMITED_ITEMS: 999,
    NO_SEARCH_NAME: ""
}